import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../lib/api';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace('#', ''));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/auth');
      return;
    }

    authAPI.googleSession(sessionId)
      .then(resp => {
        login(resp.data.user, resp.data.session_token);
        toast.success(`Welcome, ${resp.data.user.name}!`);
        const role = resp.data.user.role;
        if (role === 'super_admin' || ['finance_admin', 'translator_admin', 'support_admin'].includes(role)) {
          navigate('/admin', { replace: true, state: { user: resp.data.user } });
        } else {
          navigate('/explore', { replace: true, state: { user: resp.data.user } });
        }
      })
      .catch(err => {
        toast.error('Authentication failed. Please try again.');
        navigate('/auth', { replace: true });
      });
  }, [navigate, login]);

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-red-500/30 border-t-red-500 rounded-full animate-spin mx-auto mb-4" />
        <p className="text-gray-400 text-sm">Completing sign in...</p>
      </div>
    </div>
  );
}
